export const mutations = {
    setContrato(state, data){
        state.contrato = data
    },
    setModalVisualizarContrato(state, status){
        state.modalVisualizarContrato = status
    }
};

export default {}